import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { antConfig } from "./ant-config";
import { ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./services/Store";
import { getUserDetails } from "../src/services/Store/GetUserDetail/actions";
import { GOOGLE_CLIENT_ID } from "./helpers/constant";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { fetchCompanyDetails } from "./services/Store/Company/actions";
import { decryptWithCryptoJS } from "./helpers/commonFunctions";

// Separate component that uses Redux hooks
// add
const AppWrapper = () => {
  const { userData } = useSelector((state) => state.getUserDetails);
  const { companyDetailsData, companyDetailsLoading } = useSelector(
    (state) => state.companyDetails,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!companyDetailsData?.name) {
      dispatch(fetchCompanyDetails());
    }
  }, []);

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (companyDetailsData?.color?.primary_color) {
      const colors = companyDetailsData.color;
      document.documentElement.style.setProperty(
        "--primary-color",
        colors?.primary_color,
      );
      document.documentElement.style.setProperty(
        "--primary_color_hsla",
        colors?.primary_color_hsla,
      );
    }
  }, [companyDetailsData?.color]);

  // const key = "zsRAf4CD1gKvc3IiB5OlUhBBrw6WxwTTppQdFrfBNOE="; // Key used during encryption

  useEffect(() => {
    const decryptedValue = decryptWithCryptoJS(companyDetailsData?.credentials?.google?.client_id, process.env.REACT_APP_ED_SECRET_KEY);
    console.log("ed decryptedValue", decryptedValue);
  }, [companyDetailsData]);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ConfigProvider theme={antConfig(companyDetailsData)}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </GoogleOAuthProvider>
  );
};

// Root component that provides Redux store
const RootComponent = () => {
  return (
    // <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
    <Provider store={store}>
      <AppWrapper />
    </Provider>
    // </GoogleReCaptchaProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <RootComponent />,
  // </React.StrictMode>
);

reportWebVitals();
